
const LocationIcon = () => {
    return (
        <svg width="12" height="17" viewBox="0 0 12 17" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path d="M5.83333 0C2.6125 0 0 2.6125 0 5.83333C0 10.2083 5.83333 16.6667 5.83333 16.6667C5.83333 16.6667 11.6667 10.2083 11.6667 5.83333C11.6667 2.6125 9.05417 0 5.83333 0ZM5.83333 7.91667C4.68333 7.91667 3.75 6.98333 3.75 5.83333C3.75 4.68333 4.68333 3.75 5.83333 3.75C6.98333 3.75 7.91667 4.68333 7.91667 5.83333C7.91667 6.98333 6.98333 7.91667 5.83333 7.91667Z" fill="currentColor" />
        </svg>
    );
};

export default LocationIcon;
